import React, { useEffect, useState } from 'react';
import InputForm from '../../../InputT';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../Types/ParamsPicklist';
import { Box, CircularProgress, Collapse, IconButton, RadioGroup, TextField, Tooltip, Typography } from '@mui/material';
import { Button, Image, Input, Radio, RadioChangeEvent, Select, Space, Spin } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { Clear, DataArray, MonetizationOn, MonetizationOnOutlined, Money, NavigateBefore, NavigateNext, Phone, SkipNext, SwipeUp } from '@mui/icons-material';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../Models/Utilisateur';
import SearchInput from '../../../SearchInput';
import CheckBox from '../../../CheckBox';
import SearchModal from '../../../SearchModal';
import RadioBox from '../../../Radiox';
import TextArea from 'antd/es/input/TextArea';
import Datas from "../../../../Data/Data.json"
import { Crypter } from '../../../../Functions/Security/Crypter';
import axios from 'axios';
import DataTypeTable from '../../../../Types/DataTypeTable';
import SweetAlert from "sweetalert2"
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import Data from '../../../../Data/Data.json'
import { DownOutlined } from '@ant-design/icons';
import SelectOption from '../../../SelectOption';
import ViewImages from '../../../ViewImages';
import RELATION from '../../../../Models/Relation';
import Procuration from '../../../../Models/Procuration';
import { concat } from '@progress/kendo-data-query/dist/npm/transducers';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import { useNavigate } from 'react-router-dom';
import ParamsPicklist from '../../../../Types/ParamsPicklist';
import formatOrderDate from '../../../../Functions/Traitement/formatOrderDate';


let searchUser: Params = { CodeAgence: '', Table: "UTILIS", Colonne1: "CODUTI", Colonne2: "NOMUTI", Colagence: '001', Choix: 22 }


let searchTypAdr: Params = { CodeAgence: '', Table: "UTILIS", Colonne1: "CODUTI", Colonne2: "NOMUTI", Colagence: '001', Choix: 22 }
let searchPretForm: Params = { CodeAgence: '', Table: "PRETS", Colonne1: "NUMDOS", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }



//Initialisation des parametres de recherche
let searchTitre: Params = { CodeAgence: '', Table: "TITRES", Colonne1: "CDTITR", Colonne2: "LIBELL1", Colagence: '101', Choix: 22 }
let searchSituationFamiliale: Params = { CodeAgence: "SITFAM", Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
let searchProspect: Params = { CodeAgence: '', Table: "DEMA983", Colonne1: "CODDMR", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchClassRisque: Params = { CodeAgence: '', Table: "CLARIS", Colonne1: "CLARIS", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchPays: Params = { CodeAgence: '', Table: "CDPAYS", Colonne1: "CDPAYS", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchActivite: Params = { CodeAgence: '', Table: "TABNAE", Colonne1: "CODNAE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchUniteInstitutionnel: Params = { CodeAgence: '', Table: "TABNUI", Colonne1: "CODNUI", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchRegimeMatrimonial: Params = { CodeAgence: "REGMAT", Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
//
let searchNiveauInstruction: Params = { CodeAgence: '', Table: "INSTRU", Colonne1: "CODINS", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchEthnie: Params = { CodeAgence: '', Table: "ETHNIE", Colonne1: "CODETH", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchCateGo: Params = { CodeAgence: '', Table: "CATEGO", Colonne1: "CATEGO", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchZoneGeo: Params = { CodeAgence: '', Table: "RESIDE", Colonne1: "CDRESI", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchAgence: Params = { CodeAgence: '', Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGroup: Params = { CodeAgence: '', Table: "GROUPUSER", Colonne1: "CODGROUP", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGes: Params = { CodeAgence: 'GESTIONNAIRE', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }
let searchService: Params = { CodeAgence: '', Table: "SERVICE", Colonne1: "CODSERV", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchIndice: Params = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }
let searchCompte: Params = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '101', Choix: 22 }
let searchStatus: Params = { CodeAgence: '', Table: "Status", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchPlanCpte: Params = { CodeAgence: '', Table: "V_COMPTE_CLIENTELE_PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchPeriod: Params = { CodeAgence: '', Table: "v_period_lib", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchTypeAmort: Params = { CodeAgence: '', Table: "v_typeAmortissement_lib", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchTypeCalcul: Params = { CodeAgence: '', Table: "v_typeCalcul_lib", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchTypePret: Params = { CodeAgence: '', Table: "TYPEPRET", Colonne1: "TYPEPRET", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchNature: Params = { CodeAgence: '', Table: "TABNAE", Colonne1: "CODNAE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchMotif: Params = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchSimul: Params = { CodeAgence: '', Table: "SIMULPRET", Colonne1: "NUMSIMUL", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }

interface SelectData {
  value: string,
  label: string,
}

function Tab1(props: { form?: any }) {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  const [numcli, setNumcli] = useState("")
  const [numcpt, setNumcpt] = useState("")
  const [competClients, SetCompetClients] = React.useState<SelectData[]>([]);
  const [loading, setLoading] = useState(false)
  const [loadCompte, setLoadCompte] = useState(false)
  const [numcptEpargne, setNumcptEpargne] = useState("")
  const [accountSelected, setAccountSelected] = useState(false)
  const [typeOpe, setTypeOpe] = useState("")
  const [branchSelected, setBranchSelected] = useState(false)
  const [signataire, setSignataire] = useState<any[]>([])
  const [procuration, setProcuration] = useState<any[]>([])
  const [pageIsLoad, setPageIsLoad] = useState(true)
  const navigate = useNavigate()
  const [caisse, setCaisse] = useState<any>()
  const [agence, setAgence] = useState("")


  // USER TOKEN
  const authHeader = useAuthHeader()

  let searchCompte: Params = { CodeAgence: agence, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Init: numcli, Colagence: 'AGCCPT', Choix: 22 }

  if (pageIsLoad) {
    setPageIsLoad(false)
    LoadTillInformation()

  }

  const handleChange = (val: string) => {
    let value = val
    if (props.form.getFieldValue("CODAGE") == user.codage || props.form.getFieldValue("CODAGE") == "" || props.form.getFieldValue("CODAGE") == undefined) {
      value = value.split('|')[0]

      props.form.setFieldValue("CODAGE", user.codage)
      props.form.setFieldValue("lib_CODAGE", user.agence)

    } else {
      value = value.split('|')[1]
    }

    props.form.setFieldValue("TypeOpe", (value == '950' || value == '050') ? "VER" : (value == '951' || value == '051') ? "RET" : (value == '955') ? "ENV" : "REC")

    // setTypeOpe(value)
    // props.form.setFieldValue("CODOPE", value)
    //alert(props.form.getFieldValue("CODOPE"))

    if (value == '950' || value == '951' || value == '983') {
      props.form.setFieldValue("CODAGE", user.codage)
      props.form.setFieldValue("lib_CODAGE", user.agence)
      setBranchSelected(true)
    } else {
      // props.form.setFieldValue("CODAGE", "")
      // props.form.setFieldValue("lib_CODAGE", "")
      setBranchSelected(false)
    }
    // props.form.setFieldValue("CDGESTCLI", null)
    // props.form.setFieldValue("lib_CDGESTCLI", null)
    // props.form.setFieldValue("AUTORI", null)
    // props.form.setFieldValue("CDDEVS", null)
    // props.form.setFieldValue("lib_CDDEVS", null)
    // props.form.setFieldValue("CDGEST", null)
    // props.form.setFieldValue("BLOQUE", null)
    // props.form.setFieldValue("DISPON", null)


    setAgence(props.form.getFieldValue("CODAGE"))


    props.form.setFieldValue("CODOPE1", value)


    //props.form.setFieldValue("CODOPE", value)

    if (value == "955" || value == "983") {

      props.form.setFieldValue("CODAGE", user.codage)
      props.form.setFieldValue("lib_CODAGE", user.agence)

      loadCptMAD()
    } else {
      // props.form.setFieldValue("NUMCPT", "")
      // props.form.setFieldValue("lib_NUMCPT", "")
    }
    handleOperation(value)
  };

  const handleChangeAgence = (val: any) => {

    props.form.setFieldValue("CDGESTCLI", null)
    props.form.setFieldValue("lib_CDGESTCLI", null)
    props.form.setFieldValue("AUTORI", null)
    props.form.setFieldValue("CDDEVS", null)
    props.form.setFieldValue("lib_CDDEVS", null)
    props.form.setFieldValue("CDGEST", null)
    props.form.setFieldValue("BLOQUE", null)
    props.form.setFieldValue("DISPON", null)
    props.form.setFieldValue("NUMCPT", null)
    props.form.setFieldValue("lib_NUMCPT", null)

    props.form.setFieldValue("nomClient", null)
    props.form.setFieldValue("CNIClient", null)
    props.form.setFieldValue("TelBenef", null)
    props.form.setFieldValue("MONTAN", null)
    props.form.setFieldValue("montantOpe", null)
    props.form.setFieldValue("refOpe", null)
    props.form.setFieldValue("SERCHQ", null)
    props.form.setFieldValue("DatDelCNI", null)
    props.form.setFieldValue("montantOpe", null)
    props.form.setFieldValue("LieuDeliv", null)
    props.form.setFieldValue("DateDeliv", null)

    try {
      if (val != "" && val != undefined && typeOpe != "") {
        setBranchSelected(true)
      } else {
        setBranchSelected(false)
        setAccountSelected(false)
        //props.form.resetFields()
      }
    } catch (error) {
      setBranchSelected(false)
      setAccountSelected(false)
    }

    //alert(val)

    setAgence(val)

    setTypeOpe("")
    props.form.setFieldValue("CODOPE", null)
    props.form.setFieldValue("CODOPE1", null)
    props.form.setFieldValue("lib_CODOPE", null)


  };

  function loadProcuration(cpt: string): any {
    setLoading(true)
    setProcuration([])

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.GetProCpt,
      headers: {
        'CypherNumCpte': Crypter.encrypt(cpt),
        'Authorization': authHeader()
      }
    };

    axios.request(config)
      .then((response: any) => {
        const res = JSON.parse(Crypter.decrypt(response.data))
        var newData = [] as any;

        (res.Result.Table as []).map((s: any) => {
          newData.push(
            {
              "type": "Procuration",
              "nom": s.nom,
              "prenom": s.prenom,
              "cni": s.cni,
              "photo": s.photo,
              "signature": s.signature
            }
          )
        })
        setProcuration(newData)
        setLoading(false)
      })
      .catch((error: any) => {
        setProcuration([])
        setLoading(false)
      });
  }
  function loadSignataire(cpt: string): any {
    setLoading(true)
    setSignataire([])

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.GetSignCpt,
      headers: {
        'CypherNumCpte': Crypter.encrypt(cpt),
        'Authorization': authHeader()
      }
    };
    axios.request(config)
      .then((response: any) => {
        const res = JSON.parse(Crypter.decrypt(response.data));
        var newData = [] as any;

        (res.Result.Table as []).map((s: any) => {
          newData.push(
            {
              "type": s.INSTITULER,
              "nom": s.NomRel,
              "prenom": s.Prenom,
              "cni": s.cni,
              "photo": s.photo,
              "signature": s.signature
            }
          )
        })
        setSignataire(newData)
        setLoading(false)
      })
      .catch((error: any) => {
        setSignataire([])
        setLoading(false)
      });
  }



  const handleChangeAccount = (val: any) => {
    try {
      props.form.setFieldValue("CDGESTCLI", null)
      props.form.setFieldValue("lib_CDGESTCLI", null)
      props.form.setFieldValue("AUTORI", null)
      props.form.setFieldValue("CDDEVS", null)
      props.form.setFieldValue("lib_CDDEVS", null)
      props.form.setFieldValue("CDGEST", null)
      props.form.setFieldValue("BLOQUE", null)

      // if (val != "" && val != undefined && branchSelected) {
      //   setAccountSelected(true)

      //   loadSignataire(val as string)
      //   loadProcuration(val as string)
      //   loadAccountInformations(val as string)

      // } else {

      //   props.form.setFieldValue("CDGESTCLI", null)
      //   props.form.setFieldValue("lib_CDGESTCLI", null)
      //   props.form.setFieldValue("AUTORI", null)
      //   props.form.setFieldValue("CDDEVS", null)
      //   props.form.setFieldValue("lib_CDDEVS", null)
      //   props.form.setFieldValue("CDGEST", null)
      //   props.form.setFieldValue("BLOQUE", null)

      //   setAccountSelected(false)
      //   setSignataire([])
      //   setProcuration([])
      // }
      setAccountSelected(true)

      loadSignataire(val as string)
      loadProcuration(val as string)
      loadAccountInformations(val as string)
    } catch (error) {
      setAccountSelected(false)
      setSignataire([])
      setProcuration([])
    }
  };

  function loadAgence(agence: string) {
    setLoading(true)
    var data = { CodeAgence: agence, Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: "CODAGE", Init: "", choix: 22 }
    //alert(JSON.stringify(data))
    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherSearch': Crypter.encrypt(JSON.stringify(data))
      }
    };

    axios(config)
      .then((response) => {
        //alert('ok')
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;

          if (res.StatutCode == 200) {
            let datas = res.Result.Table;
            props.form.setFieldValue("lib_CODAGE", datas[0].LIBELLE)
          }
          else {
            SweetAlert.fire({ title: res.Message, icon: 'error' })
          }
        }
        setLoading(false);

      }).catch((error) => {
        // console.log(error)
        setLoading(false);
        // SweetAlert.fire({title: "Error", text : error})
      })
  }

  function loadAccountInformations(numcpt: string) {
    setLoading(true)
    var data = { CodeAgence: props.form.getFieldValue("CODAGE"), Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: props.form.getFieldValue("CODAGE"), Init: numcpt, choix: 33 }
    //alert(JSON.stringify(data))
    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.GetCompte,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherNumCpte': Crypter.encrypt(numcpt)
      }
    };

    axios(config)
      .then((response) => {
        //alert('ok')
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data));

          if (res.StatutCode == 200) {
            let datas = res.Result.Table;
            //alert(JSON.stringify(datas))
            //props.form.setFieldsValue(datas[0])

            props.form.setFieldValue("CDDEVS", datas[0].CDDEVS)
            props.form.setFieldValue("lib_CDDEVS", datas[0].lib_CDDEVS)

            props.form.setFieldValue("CDGESTCLI", datas[0].cdgest)
            props.form.setFieldValue("lib_CDGESTCLI", datas[0].lib_cdgest)

            props.form.setFieldValue("CODAGE", datas[0].AGCCPT)
            props.form.setFieldValue("AUTORI", formatNumber(datas[0].AUTORI))
            props.form.setFieldValue("BLOQUE", formatNumber(datas[0].BLOQUE))
            props.form.setFieldValue("DISPON", formatNumber(datas[0].DISPON))
            
            props.form.setFieldValue("nomClient", datas[0].NOMCPT)
            props.form.setFieldValue("TelBenef", datas[0].TelMobil)


            loadAgence(datas[0].AGCCPT)
          }
          else {
            SweetAlert.fire({ title: res.Message, icon: 'error' })
          }
        }
        setLoading(false);

      }).catch((error) => {
        console.log(error)
        setLoading(false);
        // SweetAlert.fire({title: "Error", text : error})
      })
  }

  function LoadTillInformation() {

    props.form.setFieldValue("DateOpe", user.datjour)
    setLoading(true)
    let utilis: Utilisateur = user
    //alert(JSON.stringify(utilis))
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.GetTillStatut,
      headers: {
        'CipherUser': Crypter.encrypt(JSON.stringify(utilis)),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };
    axios.request(config)
      .then((response) => {
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;

          //props.form.setFieldsValue(res.Result[0])

          if (res.StatutCode == 200) {

            if (res.Message.includes("cloturé") || res.Message.includes("fermé") || res.Message.includes("arrêté")) { // Lorsque la caisse est déjà ouverte

              navigate("/")
              SweetAlert.fire({ title: "Veillez au prélable ouvrir votre caisse", icon: "warning" })

            } else {
              setCaisse(res.Result[0])

              sessionStorage.setItem("caisse", JSON.stringify(res.Result[0]))

              props.form.setFieldValue("NODECE", res.Result[0].NODECE)
              props.form.setFieldValue("CAIUTI", res.Result[0].CAIUTI)

              props.form.setFieldValue("CODAGE", user.codage.trim())
              props.form.setFieldValue("lib_CODAGE", user.agence)
            }

          }
          else {
            navigate("/")
            SweetAlert.fire({ title: res.Message, icon: "warning" })
          }
        }
        setLoading(false)
      })
      .catch((error) => {
        navigate("/")
        setLoading(false);
        console.log(error)
        SweetAlert.fire({ title: error, icon: "error" })
      });
  }


  setTimeout(() => {
    try {
      let reset = localStorage.getItem(Datas.LocalVariable.reset)
      if (reset == "1") {
        //setTypeOpe("")
        setAccountSelected(false)
        setBranchSelected(false)
        setSignataire([])
        setProcuration([])
      }
      localStorage.removeItem(Data.LocalVariable.reset)
    }
    catch (error) { }
  }, 1);

  useEffect(() => {
    let value = props.form.getFieldValue("CODOPE");
    //alert(value)
    if (value && value != "") {

      //setTypeOpe(value)
      //let type = (value == '950' || value == '052') ? "VER" : (value == '951' || value == '051') ? "RET" : (value == '955') ? "ENV" : "REC"
      //props.form.setFieldValue("TypeOpe", type)
      try {
        if (value.split("|")[2] == "load") {
          loadSignataire(props.form.getFieldValue("NUMCPT"))
          loadProcuration(props.form.getFieldValue("NUMCPT"))
          props.form.setFieldValue("CODOPE", value.replaceAll('|load', "") + "")
          setTypeOpe(value.replaceAll('|load', ""))
        } else {
          setTypeOpe(value)
        }

      } catch (error) {
        setTypeOpe(value)
      }
    } else {
      setTypeOpe("")
    }
  })

  const [typeEnvoie, setTypeEnvoie] = useState(1);

  const onChangeTypeEnvoie = (e: RadioChangeEvent) => {
    setTypeEnvoie(e.target.value);
  };
  // function consult() {

  //   let ref = props.form.getFieldValue("NUMRAP")

  //   props.form.resetFields()

  //   props.form.setFieldValue("NUMRAP", ref)
  //   let search: ParamsPicklist = { CodeAgence: user.codage, Table: "CBI", Colonne1: "NUMRAP", Colonne2: "", Colagence: '101', Init: ref, Choix: 33 }
  //   setLoading(true)
  //   //form.resetFields()
  //   let config: any = {
  //     method: 'get',
  //     maxBodyLength: Infinity,
  //     url: Data.ApiUrl.AnySearch,
  //     headers: {
  //       'CypherSearch': Crypter.encrypt(JSON.stringify(search)),
  //       'Authorization': authHeader(),
  //       'Content-Type': 'application/json'
  //     },
  //   };
  //   axios.request(config)
  //     .then((response) => {
  //       setLoading(false);
  //       if (response.data) {
  //         const res = JSON.parse(Crypter.decrypt(response.data)).Value;
  //         //alert(JSON.stringify(res))

  //         console.log(res)
  //         if (res.StatutCode == 200) {
  //           localStorage.clear()

  //           console.log(res.Result.Table[0])

  //           //props.form.setFieldsValue(res.Result.Table[0])
  //           props.form.setFieldValue("CODOPE", res.Result.Table[0].CDLBEC + "|load")

  //           //alert(res.Result.Table[0].AEGECE)

  //           props.form.setFieldValue("AEGECE", res.Result.Table[0].AEGECE)
  //           props.form.setFieldValue("NODECE", res.Result.Table[0].NODECE)
  //           props.form.setFieldValue("NUMSEQ", res.Result.Table[0].NUMSEQ)
  //           props.form.setFieldValue("DRNOSE", res.Result.Table[0].DRNOSE)
  //           props.form.setFieldValue("refOpe", res.Result.Table[0].NUMRAP)
  //           props.form.setFieldValue("SENSOP", res.Result.Table[0].SENSOP)
  //           props.form.setFieldValue("NOMB01", res.Result.Table[0].NOMBO1)
  //           props.form.setFieldValue("NOMB02", res.Result.Table[0].NOMBO2)
  //           props.form.setFieldValue("NOMB03", res.Result.Table[0].NOMBO3)
  //           props.form.setFieldValue("NOMB04", res.Result.Table[0].NOMBO4)
  //           props.form.setFieldValue("NOMB05", res.Result.Table[0].NOMBO5)
  //           props.form.setFieldValue("NOMB06", res.Result.Table[0].NOMBO6)
  //           props.form.setFieldValue("NOMB07", res.Result.Table[0].NOMBO7)
  //           props.form.setFieldValue("NOMB08", res.Result.Table[0].NOMBO8)
  //           props.form.setFieldValue("NOMB09", res.Result.Table[0].NOMBO9)
  //           props.form.setFieldValue("NOMB010", res.Result.Table[0].NOMBO10)
  //           props.form.setFieldValue("NOMB011", res.Result.Table[0].NOMBO11)
  //           props.form.setFieldValue("NOMB012", res.Result.Table[0].NOMBO12)
  //           props.form.setFieldValue("NOMB013", res.Result.Table[0].NOMBO13)
  //           props.form.setFieldValue("NOMB014", res.Result.Table[0].NOMBO14)
  //           props.form.setFieldValue("NOMB015", res.Result.Table[0].NOMBO15)
  //           props.form.setFieldValue("NOMB016", res.Result.Table[0].NOMBO16)
  //           props.form.setFieldValue("NOMB017", res.Result.Table[0].NOMBO17)
  //           props.form.setFieldValue("NOMB018", res.Result.Table[0].NOMBO18)
  //           props.form.setFieldValue("NOMB019", res.Result.Table[0].NOMBO19)
  //           props.form.setFieldValue("NOMB020", res.Result.Table[0].NOMBO20)
  //           props.form.setFieldValue("NUMCPT", res.Result.Table[0].NUMCPT)
  //           props.form.setFieldValue("montantOpe", res.Result.Table[0].MONTAN)
  //           props.form.setFieldValue("DateOpe", ReformatDate(res.Result.Table[0].DATOPE))
  //           props.form.setFieldValue("OPECLI", res.Result.Table[0].OPECLI)
  //           //props.form.setFieldValue("CDLBEC", res.Result.Table[0].CDLBEC)

  //           props.form.setFieldValue("lib_CODOPE", res.Result.Table[0].LIBOPE)
  //           props.form.setFieldValue("nomClient", res.Result.Table[0].REMETT)
  //           //props.form.setFieldValue("TYPE", res.Result.Table[0].TYPE)
  //           //props.form.setFieldValue("LECEPC", res.Result.Table[0].LECEPC)
  //           props.form.setFieldValue("LITIGE", res.Result.Table[0].LITIGE)
  //           props.form.setFieldValue("UTISAI", res.Result.Table[0].UTISAI)
  //           props.form.setFieldValue("DATSAI", res.Result.Table[0].DATSAI)
  //           props.form.setFieldValue("TIME", res.Result.Table[0].TIME)
  //           props.form.setFieldValue("DEDEVR", res.Result.Table[0].DEDEVR)
  //           props.form.setFieldValue("UTIVAL", res.Result.Table[0].UTIVAL)
  //           props.form.setFieldValue("MONTDEV", res.Result.Table[0].MONTDEV)
  //           props.form.setFieldValue("TAUXDEV", res.Result.Table[0].TAUXDEV)
  //           props.form.setFieldValue("COMPTA", res.Result.Table[0].COMPTA)
  //           props.form.setFieldValue("LIGNE", res.Result.Table[0].LIGNE)
  //           props.form.setFieldValue("HOURSERV", res.Result.Table[0].HOURSERV)
  //           props.form.setFieldValue("MOIS", res.Result.Table[0].MOIS)
  //           props.form.setFieldValue("DATOPESYS", res.Result.Table[0].DATOPESYS)
  //           props.form.setFieldValue("DEDEVRSYS", res.Result.Table[0].DEDEVRSYS)
  //           props.form.setFieldValue("CNIClient", res.Result.Table[0].cniremet)
  //           props.form.setFieldValue("LieuDeliv", res.Result.Table[0].lieudelrem)
  //           props.form.setFieldValue("DateDeliv", ReformatDate(res.Result.Table[0].datdelrem))
  //           props.form.setFieldValue("uticonf", res.Result.Table[0].uticonf)
  //           props.form.setFieldValue("orderInfo", res.Result.Table[0].orderInfo)
  //           props.form.setFieldValue("coduti", res.Result.Table[0].coduti)
  //           props.form.setFieldValue("TelBenef", res.Result.Table[0].teleph)
  //           props.form.setFieldValue("ismes", res.Result.Table[0].ismes)
  //           props.form.setFieldValue("agccptCli", res.Result.Table[0].agccptCli)
  //           props.form.setFieldValue("numcptCli", res.Result.Table[0].numcptCli)
  //           props.form.setFieldValue("numcptLiai", res.Result.Table[0].numcptLiai)

  //           loadAccountInformations(res.Result.Table[0].NUMCPT)


  //           //res.Result.Table[0]


  //           //console.log(JSON.stringify(res.Result.Table))

  //           //initialiazeButton()

  //           //setConsulActive(false)

  //           //cunsultButton()

  //         }
  //         else {
  //           SweetAlert.fire({ title: res.Message, icon: "warning" })
  //         }
  //       }
  //       setLoading(false)
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       console.log(error)
  //       SweetAlert.fire({ title: error, icon: "error" })
  //     });
  // }











  function handleOperation(ref: string) {
    props.form.setFieldValue("lib_CODOPE", "")

    //let ref = props.form.getFieldValue("CODOPE")


    let search: ParamsPicklist = { CodeAgence: "", Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", colfiltre: 'CODOPE',valfiltre:ref, Init: ref, Choix: 22 }
    setLoading(true)
    //form.resetFields()
    let config: any = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.AnySearch,
      headers: {
        'CypherSearch': Crypter.encrypt(JSON.stringify(search)),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };
    axios.request(config)
      .then((response) => {
        setLoading(false);
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          //alert(JSON.stringify(res))

          console.log(res)
          if (res.StatutCode == 200) {
            props.form.setFieldValue("lib_CODOPE", res.Result.Table[0].LIBELL + " / ")
          }
          else {
            SweetAlert.fire({ title: res.Message, text: "Opération " + ref + " non configuré", icon: "warning" })
          }
        }
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false);
        console.log(error)
        SweetAlert.fire({ title: error, icon: "error" })
      });
  }

  function loadCptMAD() {
    let codage = user.codage

    let search: ParamsPicklist = { CodeAgence: user.codage, Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "cptmad", Colagence: '', Init: codage, Choix: 33 }
    setLoading(true)
    //form.resetFields()
    let config: any = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.AnySearch,
      headers: {
        'CypherSearch': Crypter.encrypt(JSON.stringify(search)),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };
    axios.request(config)
      .then((response) => {
        setLoading(false);
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          //alert(JSON.stringify(res))

          console.log(res)
          if (res.StatutCode == 200) {
            localStorage.clear()

            console.log(res.Result.Table[0])

            props.form.setFieldValue("NUMCPT", res.Result.Table[0].cptmad)
            setAccountSelected(true)


            let search2: ParamsPicklist = { CodeAgence: user.codage, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '101', Init: res.Result.Table[0].cptmad, Choix: 33 }
            let config: any = {
              method: 'get',
              maxBodyLength: Infinity,
              url: Data.ApiUrl.AnySearch,
              headers: {
                'CypherSearch': Crypter.encrypt(JSON.stringify(search2)),
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
              },
            };
            axios.request(config)
              .then((response) => {
                setLoading(false);
                if (response.data) {
                  const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                  //console.log(res)
                  if (res.StatutCode == 200) {
                    localStorage.clear()

                    //console.log(res.Result.Table[0])

                    props.form.setFieldValue("lib_NUMCPT", res.Result.Table[0].NOMCPT)
                    props.form.setFieldValue("CDDEVS", res.Result.Table[0].CDDEVS)

                    props.form.setFieldValue("CODAGE", user.codage)
                    props.form.setFieldValue("lib_CODAGE", user.agence)
                    //setBranchSelected(true)
                  }
                  else {
                    SweetAlert.fire({ title: res.Message, icon: "warning" })
                  }
                }
                setLoading(false)
              })
              .catch((error) => {
                setLoading(false);
                console.log(error)
                SweetAlert.fire({ title: error, icon: "error" })
              });
          }
          else {
            SweetAlert.fire({ title: res.Message, icon: "warning" })
          }
        }
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false);
        console.log(error)
        SweetAlert.fire({ title: error, icon: "error" })
      });


  }
  return (
    <div className='tabItemAuto'>
      <div >

        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}>  
            <legend> Détails opération caisse </legend>      
        <Box  display={"flex"} fontStyle={'inherit'} className={typeOpe=='950|050'? 'bordure11' : typeOpe=='951|051'? 'bordure12' : typeOpe=="955|955"? 'bordure13' :'bordure14'}>
          <InputForm notRequired search taille={240} label="Reférence" icon={<SwipeUp color='disabled' fontSize='small' />} name='NUMRAP' type='text' error='mobile' /><hr />
          <InputForm notRequired disabled taille={700}  name='lib_CODOPE' type='text' error='mobile' />
        </Box>
        

          <Box fontStyle={'inherit'}>
            {!(typeOpe == "955|955") ?

              <Box className='bordure1' display={'flex'} fontStyle={'inherit'}>
                <Box fontStyle={'inherit'}>
                  <Box display={"flex"} fontStyle={'inherit'}>
                    <Box fontStyle="inherit" className='border-left'>
                      <SearchModal Taille1={150} Taille2={250} width={4} handleFunction={handleChangeAgence} form={props.form} Titre="Recherche Agence" label='Agence' name='CODAGE' Parametre={searchAgence} />
                      <Box className='border-left' marginTop='-10px' marginLeft={-1}>
                        <SelectOption
                          disabled={false}
                          onchange={handleChange}
                          Size={undefined}
                          Option={[
                            { value: "950|050", label: "Versement" },
                            // { value: "050", label: "Versement Déplacé" },
                            { value: "951|051", label: "Retrait" },
                            // { value: "051", label: "Retrait Déplacé" },
                            { value: "955|955", label: "Envoi d'argent" },
                            // { value: "983", label: "Reception d'argent" },
                          ]}
                          label={'Operation'}
                          name={'CODOPE'}
                          taille={400}
                        />
                      </Box>
                      <Box marginTop={-1}>
                        <SearchModal Taille1={250} Taille2={300}  disabled={typeOpe == '955'} handleFunction={handleChangeAccount} form={props.form} Titre="Recherche Compte" label='Compte' name='NUMCPT' Parametre={searchCompte} />
                        <SearchModal Taille1={120} Taille2={420} width={3} notRequired disabled form={props.form} Titre="Recherche Dévise" label='Dévise' name='CDDEVS' Parametre={undefined} />

                      </Box>
                    </Box>
                    <Box width={'39%'} fontStyle="inherit" className='border-left'>
                      <SearchModal notRequired width={8} disabled form={props.form} Titre="Recherche Gestionnaire" label='Gestionnaire' name='CDGESTCLI' Parametre={searchGes} />
                      <InputForm width={8} notRequired disabled label='Autorisation' icon={<SwipeUp color='disabled' fontSize='small' />} name='AUTORI' type='text' error='mobile' />
                      <InputForm width={8} notRequired disabled label='Bloqué' icon={<SwipeUp color='disabled' fontSize='small' />} name='BLOQUE' type='text' error='mobile' />
                      <InputForm money width={8} notRequired disabled label='Disponible' icon={<SwipeUp color='disabled' fontSize='small' />} name='DISPON' type='text' error='mobile' />
                    </Box>
                  </Box>
                  <Box className='border-left' marginTop={-2}>
                  </Box>
                </Box>
                <Spin spinning={loading}>
                  <ViewImages data1={signataire} data2={procuration} />
                </Spin>
              </Box>
              :
              <Box className='bordure1' display={'flex'} fontStyle={'inherit'}>
                <Box fontStyle={'inherit'}>
                  <Box display={"flex"} fontStyle={'inherit'}>
                    <Box fontStyle="inherit" className='border-left'>
                      <SearchModal  width={5} handleFunction={handleChangeAgence} form={props.form} Titre="Recherche Agence" label='Agence' name='CODAGE' Parametre={searchAgence} />
                      <Box className='border-left' marginTop='-10px' marginLeft={-1}>
                        <SelectOption
                          disabled={false}
                          onchange={handleChange}
                          Size={undefined}
                          Option={[
                            { value: "950|050", label: "Versement" },
                            // { value: "050", label: "Versement Déplacé" },
                            { value: "951|051", label: "Retrait" },
                            // { value: "051", label: "Retrait Déplacé" },
                            { value: "955|955", label: "Envoi d'argent" },
                            // { value: "983", label: "Reception d'argent" },
                          ]}
                          label={'Operation'}
                          name={'CODOPE'}
                        />
                        <Box margin={-1} fontStyle={'inherit'} display={"flex"}>
                        </Box>
                        <br />
                      </Box><br />
                      <Box marginTop={-5}>
                        <SearchModal width={5} disabled={!branchSelected} handleFunction={handleChangeAccount} form={props.form} Titre="Recherche Compte" label='Compte' name='NUMCPT' Parametre={searchCompte} />
                        <SearchModal width={5} disabled form={props.form} Titre="Recherche Dévise" label='Dévise' name='CDDEVS' Parametre={undefined} />
                      </Box>
                    </Box>
                    <Box width={'39%'} fontStyle="inherit" className='border-left'>
                      {/* <InputForm label='N° Bordereau' icon={<SwipeUp color='disabled' fontSize='small' />} name='NUMBORDEREAU' type='text' error='mobile' /> */}
                      <InputForm width={10} notRequired disabled label='N° Order' icon={<SwipeUp color='disabled' fontSize='small' />} name='ORDREMAD' type='text' error='mobile' />
                      <InputForm width={10} notRequired disabled label='Reférence' icon={<SwipeUp color='disabled' fontSize='small' />} name='REFMAD' type='text' error='mobile' />
                      <InputForm width={10} label='Code Sécrêt' icon={<SwipeUp color='disabled' fontSize='small' />} name='CODCONFIDENCE' type='text' error='mobile' />
                    </Box>
                  </Box>
                  <Box className='border-left' marginTop={-2}>
                  </Box>
                </Box>
                <Spin spinning={loading}>
                  <InputForm width={11} disabled={typeOpe != "955|955"} label='Nom Béneficiaire' icon={<SwipeUp color='disabled' fontSize='small' />} name='nombene' type='text' error='mobile' />
                  <InputForm width={11} disabled={typeOpe != "955|955"} label='Tel Béneficiaire' icon={<SwipeUp color='disabled' fontSize='small' />} name='telbene' type='text' error='mobile' />
                  <InputForm width={11} disabled={typeOpe != "955|955"} label='CNI Béneficiaire' icon={<SwipeUp color='disabled' fontSize='small' />} name='cnibene' type='text' error='mobile' />
                </Spin>
              </Box>
            }
            {(typeOpe != '') ?
              <Box className='bordure1 border-left' fontStyle={'inherit'}>
                <Box fontStyle={"inherit"} display={"flex"}>
                  <InputForm taille={50} label="Lib opért°" disabled name='CODOPE1' type='text' error='mobile' /><hr />
                  <InputForm taille={800} name='lib_CODOPE' type='text' row={3} error='mobile' />
                </Box>
                <Box display={'flex'} fontStyle={'inherit'}>
                  <Box fontStyle={'inherit'}>
                    <Box display={"flex"} fontStyle={'inherit'}>
                      <Box fontStyle="inherit" className='border-left'>
                        <InputForm money width={9} label="Montant" disabled={!accountSelected} icon={<SwipeUp color='disabled' fontSize='small' />} name='montantOpe' type='number' error='mobile' />
                        <InputForm width={9} value={formatOrderDate(user.datjour)} notRequired disabled label="Date opération" icon={<SwipeUp color='disabled' fontSize='small' />} type='date' error='mobile' />
                        <Box display={"flex"} fontStyle={"inherit"}>
                          <InputForm width={(typeOpe == '951|051')? 12: 9} label={"" + ((typeOpe == '950|050') ? "Reférence Ope" : ((typeOpe == '951|051') ? "N°/S Chèque" : (typeOpe == '955|955') ? "N° Bordereau" : "N° Bordereau"))} disabled={!accountSelected} icon={<SwipeUp color='disabled' fontSize='small' />} name={(typeOpe == '955|983') ? 'NUMBORDEREAU' : "refOpe"} type='text' error='mobile' />
                          {(typeOpe == '951|051')?<InputForm taille={80} disabled={!accountSelected} name={"SERCHQ"} type='text' error='mobile' /> : ""}
                        </Box>
                        {/* <InputForm width={9} label="Date délivrance" notRequired disabled icon={<SwipeUp color='disabled' fontSize='small' />} name='dateheure' type='text' error='mobile' /> */}
                      </Box>
                      <Box fontStyle="inherit" className='border-left'>
                        <InputForm width={9} label={((typeOpe == '950|050') ? "Remettant" : ((typeOpe == '951|051') ? "Bénéficiaire" : (typeOpe == '955|955') ? "Expéditeur" : "Bénéficiaire"))} disabled={!accountSelected} icon={<SwipeUp color='disabled' fontSize='small' />} name='nomClient' type='text' error='mobile' />
                        <InputForm width={9} label={"CNI " + ((typeOpe == '950|050') ? "Remettant" : ((typeOpe == '951|051') ? "Bénéficiaire" : (typeOpe == '955|955') ? "Expéditeur" : "Bénéficiaire"))} disabled={!accountSelected} icon={<SwipeUp color='disabled' fontSize='small' />} name='CNIClient' type='text' error='mobile' />
                        <InputForm width={9} label="Date délivrance" disabled={!accountSelected} icon={<SwipeUp color='disabled' fontSize='small' />} name='DateDeliv' type='date' error='mobile' />
                      </Box>
                    </Box>
                  </Box>
                  <Box display={"flex"} className='border-left' fontStyle={"inherit"}>
                    <Box fontStyle="inherit" className='border-left'>
                      <InputForm width={9} label={(typeOpe == "955|955") ? "Tel Expéditeur" : "Tel Bénéficiaire"} disabled={!accountSelected} icon={<SwipeUp color='disabled' fontSize='small' />} name='TelBenef' type='text' error='mobile' />
                      <InputForm width={9} label="Lieu Délivrance" disabled={!accountSelected} icon={<SwipeUp color='disabled' fontSize='small' />} name='LieuDeliv' type='text' error='mobile' />
                    </Box>
                  </Box>
                </Box>
                <Box display={'flex'} className={typeOpe=='950|050'? 'bordure11' : typeOpe=='951|051'? 'bordure12' : typeOpe=="955|955"? 'bordure13' :'bordure14'} fontStyle={'inherit'}>
                  <InputForm disabled label='Caisse' type={'text'} value={caisse.NODECE + ' - ' + caisse.LECEON} />
                  <hr />
                  <InputForm disabled label='Utilisateur de la Caisse' type={'text'} value={caisse.CAIUTI} />
                  <hr />
                  <InputForm disabled label='Compte Caisse' type={'text'} value={caisse.NUMCPT} />
                </Box>
                {/* <Box position={"relative"} top={"-35px"} margin={2.5} fontStyle={'inherit'}>
                  <Box position={"relative"} display={"flex"} fontStyle={'inherit'}>
                    <CheckBox label='Appliquer commission' form={props.form} />
                    <InputForm label="Monatant à percevoir" disabled icon={<SwipeUp color='disabled' fontSize='small' />} name='DATEDEM' type='text' error='mobile' />
                    <hr />
                    <InputForm width={15} label='Compte Caisse' type={'text'} />
                    <InputForm type={'text'} />
                    <InputForm type={'text'} />
                  </Box>
                </Box> */}
              </Box>
              :
              ""
            }

          </Box>
        </Box>


      </div>
    </div>
  )
}

export default Tab1;